import React from 'react';
import { Field, FormSection } from 'redux-form';

function CompanySection(props) {
  const { sectionName, languageKey, fieldComponent } = props;
  const lang = languageKey.toUpperCase();
  return (
    <FormSection
      name={sectionName}
    >
      <FormSection
        name="name"
      >
        <Field
          label={`Name (${lang})`}
          name={languageKey}
          placeholder="Name"
          component={fieldComponent}
        />
      </FormSection>
      <FormSection
        name="district"
      >
        <Field
          label={`District (${lang})`}
          name={languageKey}
          placeholder="District"
          component={fieldComponent}
        />
      </FormSection>
      <FormSection
        name="province"
      >
        <Field
          label={`Province (${lang})`}
          name={languageKey}
          placeholder="Province"
          component={fieldComponent}
        />
      </FormSection>
      <FormSection
        name="country"
      >
        <Field
          label={`Country (${lang})`}
          name={languageKey}
          placeholder="Country"
          component={fieldComponent}
        />
      </FormSection>
    </FormSection>
  );
}

export default CompanySection;


// WEBPACK FOOTER //
// ./src/views/products/form-sections/CompanySection.jsx